import { Alert } from '@mui/material';
import React from 'react';
import ReactImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
const ImageGallery = ({images}) => {
    
      
    return (
        images?.length > 0 ? <ReactImageGallery items={images} /> : <Alert severity='error'>No images to display</Alert>
    );
};

export default ImageGallery;